import { Alert } from "@mui/material";
import { Formik, useField } from "formik";
import { useSnackbar } from "notistack";
import { Dispatch } from "react";
import { useNavigate } from "react-router-dom";
import { getToken } from "Services/api/auth/auth";
import { LoginData } from "Services/api/auth/interfaces";
import FormikCheckbox from "Shared/FormikCheckbox/FormikCheckbox";
import FormikForm from "Shared/FormikForm/FormikForm";
import { otpCodeSchema, OtpValidation } from "Shared/OtpValidation/OtpValidation";
import { GENERIC_ERROR_MESSAGE } from "Utils/constants";
import { requiredValidation } from "Utils/validations";
import * as Yup from "yup";

export default function OtpStep({ model, setModel }: { model: LoginData; setModel: Dispatch<LoginData> }): JSX.Element {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const uid = model.uid || "";
  const token = model.token || "";

  return (
    <Formik
      initialValues={{ channel: "", code: "", trustDevice: false }}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          const { status, data } = await getToken({
            ...model,
            ...values,
          });

          if (status === "success") {
            sessionStorage.setItem("token", data.access);
            sessionStorage.setItem("refresh", data.refresh);
            navigate("/");
          } else {
            if (data.errorKey === "invalidToken")
              setModel({
                ...model,
                status: "login",
              });
            enqueueSnackbar(data.message, { variant: "error" });
          }
        } catch (error) {
          enqueueSnackbar(GENERIC_ERROR_MESSAGE, { variant: "error" });
          console.error(error);
        }

        setSubmitting(false);
      }}
      validationSchema={Yup.object({
        channel: requiredValidation,
        code: otpCodeSchema,
        trustDevice: Yup.boolean().required(),
      })}
    >
      <FormikForm width="100%">
        <OtpValidation
          loginData={{ uid, token }}
          additionalFormNode={<SaveDevice />}
          onBack={() =>
            setModel({
              ...model,
              status: "login",
            })
          }
        />
      </FormikForm>
    </Formik>
  );
}

function SaveDevice() {
  const name = "trustDevice";
  const [{ value: channel }] = useField<string>("channel");
  const [{ value: trustDevice }] = useField<boolean>(name);

  if (!channel) return null;

  return (
    <>
      <FormikCheckbox name={name} label="Recuerda mi dispositivo y omite la verificación la próxima vez." />
      {trustDevice && (
        <Alert severity="warning" variant="outlined">
          <strong>IMPORTANTE:</strong> No confies en dispositivos o redes de uso público.
        </Alert>
      )}
    </>
  );
}
